import React, { Fragment } from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {translate} from 'react-i18next';
import { Col, Row,  Card, Button } from 'antd';
import EnhancedModal from '../../../../../components/enhanced-modal';
import DraggableCheckList from "../../../../../components/draggable-check-list";
import { hideSelectSort, checkHeadersSelectSort, changeMergedHeaderSelectSort, submitOrderedMergedList} from './actions';
import { MARGIN_MD, MODAL_WIDTH_SM } from '../../../../../styles/constants';
import _ from "lodash";

const mapStateToProps = state => ({
  selectSortShow: state.scenes.dataManager.fileMapping.components.wizard.shared.selectSortShow,
  mergedHeader: state.scenes.dataManager.fileMapping.components.wizard.shared.mergedHeaderTemp,
  checkedHeader: state.scenes.dataManager.fileMapping.components.wizard.shared.checkedHeaderTemp,
});

const mapDispatchToProps = dispatch => ({
  onSelectSortHide: () => dispatch(hideSelectSort()),
  onChange: headers => dispatch(changeMergedHeaderSelectSort(headers)),
  onHeadersCheck: headers => dispatch(checkHeadersSelectSort(headers)),
  onSubmit: () => dispatch(submitOrderedMergedList()),
});

const onDrop = (ev, cols) => {
  const array = _.cloneDeep(cols.map(x => x.name));
  const pos = ev.node.props.pos.split('-');
  const dropPos = ev.dropPosition - Number(pos[pos.length - 1]);

  const from = array.indexOf(ev.dragNode.props.eventKey);
  let to = array.indexOf(ev.node.props.eventKey);
  to = from < to
    ? dropPos < 0 // moving forward into the array
      ? to - 1 // dropPos = -1 => drag on top node gap
      : to // dropPos = 1 => drag on bottom node gap
    : dropPos < 0 // moving backwards into the array
      ? to // dropPos = -1 => drag on top node gap
      : to + 1; // dropPos = 1 => drag on bottom node gap
  if (to === -1) {
    to = 0
  }
  if (to === array.length + 1) {
    to = array.length
  }

  array.splice(to, 0, array.splice(from, 1)[0]);
  const result = array.map((name, i) => ({
    'name': name,
    'originalName': cols[cols.map(x => x.name).indexOf(array[i])].originalName,
    'added': cols[cols.map(x => x.name).indexOf(array[i])].added,
    'selected': cols[cols.map(x => x.name).indexOf(array[i])].selected,
  }))

  return result
};

  const findIcon = label => {
    return "";
  };

const FileMappingWizardHeadersSortColumn = ({
                                      t,
                                      form,
                                      selectSortShow,
                                      onSelectSortHide,
                                      onHeadersCheck,
                                      checkedHeader,
                                      mergedHeader,
                                      onChange,
                                      onSubmit,
                                    }) => {

  return (
    
    <Fragment>
      <EnhancedModal
        visible={selectSortShow}
        width={MODAL_WIDTH_SM}
        title={t('scenes.dataManager.fileMapping.wizard.sortSelectList.title')}
        onCancel={onSelectSortHide}
        footer={
          <div>
            <Button onClick={onSelectSortHide}>{t('commons.buttons.close.title')}</Button>
            <Button
              type="primary"
              onClick={() => onSubmit()}
            >
              {t('scenes.dataManager.fileMapping.wizard.sortSelectList.submit.label')}
            </Button>
          </div>
      }
      >
        <Row type="flex" justify="center">
            <Col style={{width: MODAL_WIDTH_SM}}>
                <Card
                    type="inner"
                    bodyStyle={{overflow: "auto"}}
                    style={{marginTop: MARGIN_MD}}
                  >
                    <div className="draggable-check-list-drag-over">
                      {mergedHeader && (
                        <DraggableCheckList
                          items={mergedHeader.map(x => x.name)}
                          getItemLabel={item => item}
                          getItemIcon={item => findIcon(item)}
                          getItemKey={item => item}
                          checkedKeys={checkedHeader}
                          onCheck={onHeadersCheck}
                          onDrop={ev => onChange(onDrop(ev, mergedHeader))}
                        />
                        )}
                    </div>
                </Card>
            </Col>
        </Row>
      </EnhancedModal>
    </Fragment>

);
}

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps)
  )(FileMappingWizardHeadersSortColumn);